/* eslint-disable class-methods-use-this */
export default class ConsentRule {
  isSupport(filters, node) {
    return filters.highlightPriorToConsent && node.data?.attributes?.is_prior_to_consent;
  }
  
  getStrokeColor(filters, node, result) {
    return `${result.at(result.length - 1)}60`;
  }
  getBorderColor(filters, node, result) {
    return `${result.at(result.length - 1)}60`;
  }
  getTextColor(filters, node, result) {
    return `${result.at(result.length - 1)}60`;
  }
  getNodeBackgroundColor(filters, node, result) {
    return `${result.at(result.length - 1)}60`;
  }
}
